import { RowCrudStatus } from "../../common/types";
import { BotError } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type BotErrorValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  screenshot: string;
  screenshot_data: FileCRUDType;
  __screenshot_files: FileCRUDType[];
  domSnapshot: string;
  domSnapshot_data: FileCRUDType;
  __domSnapshot_files: FileCRUDType[];
};

export type BotErrorErrorsType = {
  screenshot?: { message: string; fieldLabel: string };
  domSnapshot?: { message: string; fieldLabel: string };
};

export function BotErrorValuesInit(): BotErrorValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    screenshot: "",
    screenshot_data: fileCRUDInit(),
    __screenshot_files: [],
    domSnapshot: "",
    domSnapshot_data: fileCRUDInit(),
    __domSnapshot_files: [],
  };
}

export type BotErrorType = BotError | BotErrorValuesType;

export function botErrorDisplayId(
  source: Partial<BotError>,
  _langStore: LangStore
) {
  return "BotError" + (source.id ?? _langStore.emptyStringSymbol);
}

export function getBotErrorValues(
  source: BotErrorType,
  _langStore: LangStore,
  _duplicated: boolean = false
): BotErrorValuesType {
  const entityValues = BotErrorValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : botErrorDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.__screenshot_files =
    source.screenshot_data && !_duplicated
      ? [
          {
            id:
              "id" in source.screenshot_data && source.screenshot_data.id
                ? source.screenshot_data.id
                : `generated_${uniqueCounter++}`,
            name: source.screenshot_data.name,
            description: source.screenshot_data.description || undefined,
            size: source.screenshot_data.size || 0,
            formattedSize: source.screenshot_data.size
              ? formatBytes(source.screenshot_data.size)
              : "",
            mimetype: source.screenshot_data.mimetype,
            url: source.screenshot_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.screenshot =
    source.screenshot && !_duplicated ? source.screenshot : "";
  entityValues.screenshot_data =
    source.screenshot_data && "__status__" in source.screenshot_data
      ? source.screenshot_data
      : source.screenshot_data
      ? {
          id: ("id" in source.screenshot_data && source.screenshot_data.id
            ? source.screenshot_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.screenshot_data.name,
          description: source.screenshot_data.description || undefined,
          size: source.screenshot_data.size || 0,
          formattedSize: source.screenshot_data.size
            ? formatBytes(source.screenshot_data.size)
            : "",
          mimetype: source.screenshot_data.mimetype,
          url: source.screenshot_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  entityValues.__domSnapshot_files =
    source.domSnapshot_data && !_duplicated
      ? [
          {
            id:
              "id" in source.domSnapshot_data && source.domSnapshot_data.id
                ? source.domSnapshot_data.id
                : `generated_${uniqueCounter++}`,
            name: source.domSnapshot_data.name,
            description: source.domSnapshot_data.description || undefined,
            size: source.domSnapshot_data.size || 0,
            formattedSize: source.domSnapshot_data.size
              ? formatBytes(source.domSnapshot_data.size)
              : "",
            mimetype: source.domSnapshot_data.mimetype,
            url: source.domSnapshot_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.domSnapshot =
    source.domSnapshot && !_duplicated ? source.domSnapshot : "";
  entityValues.domSnapshot_data =
    source.domSnapshot_data && "__status__" in source.domSnapshot_data
      ? source.domSnapshot_data
      : source.domSnapshot_data
      ? {
          id: ("id" in source.domSnapshot_data && source.domSnapshot_data.id
            ? source.domSnapshot_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.domSnapshot_data.name,
          description: source.domSnapshot_data.description || undefined,
          size: source.domSnapshot_data.size || 0,
          formattedSize: source.domSnapshot_data.size
            ? formatBytes(source.domSnapshot_data.size)
            : "",
          mimetype: source.domSnapshot_data.mimetype,
          url: source.domSnapshot_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
